module.exports = __webpack_public_path__ + "img/partner8.32eb7ff9.png";